// extracted by mini-css-extract-plugin
export default {"input":"TextInputForDisplay_input__lU04R","label":"TextInputForDisplay_label__8qcWL"};